<script setup>
// NOTICE: KAPTION-INTEGRATION
// desktop-notifications-nudge.ACCOUNT.1..3
//
// Account-wide opt-in for the desktop-notification nudge. Off, nothing
// changes for anyone. On, every agent in the account who has not granted
// browser permission gets the ribbon at the top of the dashboard until they
// do. This route is administrator-gated, so the control is admin-only by
// construction.
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import { useKaptionFeatureFlags } from 'dashboard/composables/useKaptionFeatureFlags';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const { currentAccount, updateAccount } = useAccount();
const { isKaptionFlagEnabled } = useKaptionFeatureFlags();

const isEnabled = ref(false);

watch(
  currentAccount,
  () => {
    const { desktop_notifications_prompt: prompt } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!prompt;
  },
  { deep: true, immediate: true }
);

const toggle = async () => {
  try {
    await updateAccount({ desktop_notifications_prompt: isEnabled.value });
    useAlert(
      t('GENERAL_SETTINGS.FORM.KAPTION_DESKTOP_NOTIFICATIONS.API.SUCCESS')
    );
  } catch (error) {
    // Put the switch back where the server still has it, so the control never
    // shows a state that was not saved.
    isEnabled.value = !isEnabled.value;
    useAlert(
      t('GENERAL_SETTINGS.FORM.KAPTION_DESKTOP_NOTIFICATIONS.API.ERROR')
    );
  }
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <SectionLayout
    v-if="isKaptionFlagEnabled('KAPTION_DESKTOP_NOTIFICATIONS_NUDGE')"
    :title="t('GENERAL_SETTINGS.FORM.KAPTION_DESKTOP_NOTIFICATIONS.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.KAPTION_DESKTOP_NOTIFICATIONS.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch v-model="isEnabled" @change="toggle" />
      </div>
    </template>
  </SectionLayout>
</template>
